import { gql } from "@apollo/client";
import { DELIVERY_TASK_ORDER_FIELDS, DeliveryTaskOrderType } from "../types/DeliveryTaskOrderType";
import { client } from "graphql/client";

export const GET_DELIVERY_TASK_ORDER_BY_TRACKING_NUMBER = gql`
    query GetDeliveryTaskOrderByTrackingNumber($trackingNumber: String!,$isTransferIn: Boolean) {
        getDeliveryTaskOrderByTrackingNumber(trackingNumber: $trackingNumber,isTransferIn: $isTransferIn) {
            ...DeliveryTaskOrderFields
        }
    }
    ${DELIVERY_TASK_ORDER_FIELDS}
`;

export interface GetDeliveryTaskOrderByTrackingNumberResponse {
    getDeliveryTaskOrderByTrackingNumber: DeliveryTaskOrderType;
}

export const getDeliveryTaskOrderByTrackingNumber = async (trackingNumber: string) => {
    const { data } = await client.query<GetDeliveryTaskOrderByTrackingNumberResponse>({
        query: GET_DELIVERY_TASK_ORDER_BY_TRACKING_NUMBER,
        variables: { trackingNumber },
    });
    return data?.getDeliveryTaskOrderByTrackingNumber;
};



